import { ServiceFetch } from '../service-fetch'

export default class StockZoneModel extends ServiceFetch {
    getStockZoneBy = (data) => this.authFetch({
        url: 'stock-zone/getStockZoneBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}